import React from 'react';
import AppConstants from 'AppConstants';
import {ReactTitle} from 'react-meta-tags';
import axios from 'axios';
import Page from 'components/Page';
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText
  } from 'reactstrap';
  import  { Link } from 'react-router-dom';
  import ReactDOM from 'react-dom';
  import Switch from "react-switch";
class AddMentor extends React.Component{
    constructor() {
        super()
        this.state = {
            firstname : "",
            middlename : "",
            lastname : "",
            gender : "",
            street : "",
            city : "",
            state : "",
            zip : "",
            homephone : "",
            mobilephone : "",
            nameaddressofemployer : "",
            workphone : "",
            occupation : "",
            emailaddress : "",
            errors : {},
            errMsg : "",
            status:false,
            firstname_error : false,
            middlename_error : false, 
            lastname_error : false,
            gender_error : false,
            street_error : false,
            city_error : false,
            state_error : false,
            zip_error : false,
            homephone_error : false,
            mobilephone_error : false,
            nameaddressofemployer_error : false,
            workphone_error : false,
            occupation_error : false,
            emailaddress_error : false,
            status_error : false,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(checked) {
        this.setState({ status : checked });
    }
    handleValidation(){
        let errors = {};
        let formIsValid = true;
     
        if (!this.state.emailaddress){
            formIsValid = false;
            errors["emailaddress"] = "Please enter email";
            ReactDOM.findDOMNode(this.refs.emailaddress).focus();
        }       
        if(this.state.emailaddress !== ""){
            let lastAtPos = this.state.emailaddress.lastIndexOf('@');
            let lastDotPos = this.state.emailaddress.lastIndexOf('.');
      
        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.emailaddress.indexOf('@@') == -1 && lastDotPos > 2 && (this.state.emailaddress.length - lastDotPos) > 2)) {
            formIsValid = false;
            errors["emailaddress"] = "Please enter valid email";
            ReactDOM.findDOMNode(this.refs.emailaddress).focus();
        }
        }
        if (!this.state.occupation){
            formIsValid = false;
            errors["occupation"] = "Please enter occupation";
            ReactDOM.findDOMNode(this.refs.occupation).focus();
        }
        if (!this.state.nameaddressofemployer){
            formIsValid = false;
            errors["nameaddressofemployer"] = "Please enter name/address of employer";
            ReactDOM.findDOMNode(this.refs.nameaddressofemployer).focus();
        }
        if (!this.state.mobilephone){
            formIsValid = false;
            errors["mobilephone"] = "Please enter mobile phone";
            ReactDOM.findDOMNode(this.refs.mobilephone).focus();
        } else if(this.state.mobilephone.length!=10){
            formIsValid = false;
            errors["mobilephone"] = "Please enter 10 digits home phone number";
            ReactDOM.findDOMNode(this.refs.mobilephone).focus();
        }
        if (!this.state.homephone){
            formIsValid = false;
            errors["homephone"] = "Please enter home phone";
            ReactDOM.findDOMNode(this.refs.homephone).focus();
        } else if(this.state.homephone.length!=10){
            formIsValid = false;
            errors["homephone"] = "Please enter 10 digits home phone number";
            ReactDOM.findDOMNode(this.refs.homephone).focus();
        }
        if (!this.state.zip){
            formIsValid = false;
            errors["zip"] = "Please enter zip";
            ReactDOM.findDOMNode(this.refs.zip).focus();
        }
        if (!this.state.state){
            formIsValid = false;
            errors["state"] = "Please enter state";
            ReactDOM.findDOMNode(this.refs.state).focus();
        }
        if (!this.state.city){
            formIsValid = false;
            errors["city"] = "Please enter city";
            ReactDOM.findDOMNode(this.refs.city).focus();
        }
        if (!this.state.street){
            formIsValid = false;
            errors["street"] = "Please enter street";
            ReactDOM.findDOMNode(this.refs.street).focus();
        }
        if (!this.state.gender){
            formIsValid = false;
            errors["gender"] = "Please select gender";
            ReactDOM.findDOMNode(this.refs.gender).focus();
        }
        if (!this.state.lastname){
            formIsValid = false;
            errors["lastname"] = "Please enter last Name";
            ReactDOM.findDOMNode(this.refs.lastname).focus();
        }
        if (!this.state.firstname){
            formIsValid = false;
            errors["firstname"] = "Please enter first name";
            ReactDOM.findDOMNode(this.refs.firstname).focus();
        }
        this.setState({
            errors: errors,
            firstname_error : true,
            middlename_error : true, 
            lastname_error : true,
            gender_error : true,
            street_error : true,
            city_error : true,
            state_error : true,
            zip_error : true,
            homephone_error : true,
            mobilephone_error : true,
            nameaddressofemployer_error : true,
            workphone_error : true,
            occupation_error : true,
            emailaddress_error : true,
            status_error : true,
        });
        return formIsValid;
    }


    handleInputChange(e){
        // console.log(e.target.name)
        if (e.target.name == "firstname"){
            this.setState({firstname_error:false})
        }
        
        if (e.target.name == "lastname"){
            this.setState({lastname_error:false})
        }
       
        if (e.target.name == "city"){
            this.setState({city_error:false})
        }
        if (e.target.name == "state"){
            this.setState({state_error:false})
        }
        if (e.target.name == "street"){
            this.setState({street_error:false})
        }
        if (e.target.name == "zip"){
            this.setState({zip_error:false})
        }

        if (e.target.name == "homephone"){
            this.setState({homephone_error:false})
        } 
        if (e.target.name == "mobilephone"){
            this.setState({mobilephone_error:false})
        } 
        if (e.target.name == "occupation"){
            this.setState({occupation_error:false})
        }

        if (e.target.name == "emailaddress"){
            this.setState({emailaddress_error:false})
        }
        if (e.target.name == "gender"){
            this.setState({gender_error:false})
        }
        if (e.target.name == "nameaddressofemployer"){
            this.setState({nameaddressofemployer_error:false})
        }
        if(e.target.name == "emailaddress"){
            let lastAtPos = this.state.emailaddress.lastIndexOf('@');
            let lastDotPos = this.state.emailaddress.lastIndexOf('.');
            this.setState({emailaddress_error:false})
            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.emailaddress.indexOf('@@') == -1 && lastDotPos > 2 && (this.state.emailaddress.length - lastDotPos) > 2)) {
                this.setState({emailaddress_error:false})
            }
        }
        this.setState({[e.target.name]:e.target.value});
    }
    
    handleSubmit(e){
        e.preventDefault();
        let formval={} 
        
        if(this.handleValidation()){
            this.setState({loading:1});
            formval={
                'first_name' : this.state.firstname,
                'middle_name' : this.state.middlename,
                'last_name' : this.state.lastname,
                'gender': this.state.gender,
                'street' : this.state.street,
                'city' : this.state.city,
                'state' : this.state.state,
                'zipcode' : this.state.zip,
                'home_phone' : this.state.homephone,
                'mobile_phone' : this.state.mobilephone,
                'employer_address' : this.state.nameaddressofemployer,
                'work_phone' : this.state.workphone,
                'occupation' : this.state.occupation,
                'email' : this.state.emailaddress,
                'status':this.state.status
            }
            axios.post(AppConstants.API+'/mentor/updateMentor/'+this.props.match.params.id,formval)
            .then(res => {   
             if(res.data.Status == "Success"){
              setTimeout((e) => {
                  this.props.history.push('/allMentors');
              }, 2000);
              setTimeout(() => {
                this.setState({
                  loading:'',
                  errMsg:  (<div className="alert alert-success fade show mt-3">{res.data.msg}</div>),
                });
              }, 1000);
            }
            else{
              setTimeout(() => {
                this.setState({
                  loading:'',
                  errMsg:  (<div className="alert alert-danger fade show mt-3">{res.data.msg}</div>),
                });
              }, 1000);
            }
          });
        } 
    }

    componentDidMount(){
        fetch(AppConstants.API+'/mentor/getMentorData/' + this.props.match.params.id).then(res=>{
            if(res.status == 200){
                return res.json();
              }
            }).then(data=>{
                this.setState({
                firstname: data.data[0].first_name,
                middlename: data.data[0].middle_name,
                lastname: data.data[0].last_name, 
                gender: data.data[0].gender, 
                street: data.data[0].street, 
                city: data.data[0].city, 
                state: data.data[0].state, 
                zip: data.data[0].zipcode, 
                homephone: data.data[0].home_phone, 
                mobilephone: data.data[0].mobile_phone, 
                nameaddressofemployer: data.data[0].employer_address,
                workphone: data.data[0].work_phone,
                occupation: data.data[0].occupation,
                emailaddress: data.data[0].email,
                status:data.data[0].status
                })
        });
        var element = document.getElementById("navItem-Mentors-2");
        element.classList.add("active");
    }

    
    render(){
        return(
            <Page title="Edit Mentor">
                <ReactTitle title="Edit Mentor"/>
                <ul className="cst-breadcrumb">
                    <li><Link to={'/dashboard'}>Home</Link></li>
                    <li><Link to={'/allmentors'}>All Participants</Link></li>
                    <li>Edit Participant</li>
                </ul>
                <Row>
                <Col xl={12} lg={12} md={12}>
                        <Card className="pt-0 addmntr">
                        <CardHeader>Personal Information:</CardHeader>
                            <CardBody>
                                <Form name="addchild" onSubmit= { this.handleSubmit }>
                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                            Name <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                            <div className="d-flex justify-content-around">

                                            <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>First Name</InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="text"
                                            name="firstname"                     
                                            value={this.state.firstname}
                                            onChange={ this.handleInputChange }   
                                            ref ="firstname"   />
                                            {this.state.firstname_error == true? <span className="error" style={{color: 'red'}}>{this.state.errors["firstname"]}</span>:""}
                                            </InputGroup>
                                            
                                            <InputGroup className="mx-3">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Middle Name</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="middlename"                     
                                            value={this.state.middlename}
                                            onChange={ this.handleInputChange }   
                                            ref ="middlename"  />
                                            </InputGroup>
                                            
                                            <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Last Name</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="lastname"                     
                                            value={this.state.lastname}
                                            onChange={ this.handleInputChange }   
                                            ref ="lastname"  />
                                            {this.state.lastname_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["lastname"]}</span> :""}
                                            
                                            </InputGroup>
                                            </div>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                            Gender <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                            <div className="d-flex justify-content-left">
                                                <FormGroup check className="mr-3">
                                                <Label check>
                                                <Input type="radio"  name="gender" value="male" ref ="gender" 
                                                checked={this.state.gender=='male'}
                                                onChange={ this.handleInputChange }/> Male</Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                <Label check>
                                                <Input type="radio"  name="gender" value="female" 
                                                checked={this.state.gender=='female' } ref ="gender"  
                                                onChange={ this.handleInputChange }/> Female</Label>
                                                </FormGroup>
                                               {this.state.gender_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["gender"]}</span> : ""}
                                            </div>
                                            
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                        Address <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                            <div className="d-flex justify-content-left mb-3">

                                            <InputGroup >
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Street</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="street"                     
                                            value={this.state.street}
                                            onChange={ this.handleInputChange }   
                                            ref ="street"  />
                                            {this.state.state_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["street"]}</span>:""}
                                            </InputGroup>
                                            
                                            </div>

                                            <div className="d-flex justify-content-left mb-3">

                                            <InputGroup  className="mr-3">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>City</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="city"                     
                                            value={this.state.city}
                                            onChange={ this.handleInputChange }   
                                            ref ="city"  />
                                            {this.state.city_error == true ?<span className="error" style={{color: 'red'}}>{this.state.errors["city"]}</span>:""}
                                            </InputGroup>    
                                              
                                            <InputGroup className="mr-3">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>State</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="state"                     
                                            value={this.state.state}
                                            onChange={ this.handleInputChange }   
                                            ref ="state"  />
                                            {this.state.state_error == true?<span className="error" style={{color: 'red'}}>{this.state.errors["state"]}</span>:""}
                                            </InputGroup>
                                            

                                            <InputGroup className="col-3 p-0">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Zip</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="zip"                     
                                            value={this.state.zip}
                                            onChange={ this.handleInputChange }   
                                            ref ="zip"  />
                                            {this.state.zip_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["zip"]}</span>:""}
                                            </InputGroup>
                                            
                                            </div>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                       Phone <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                            <div className="d-flex justify-content-left">
                                            <InputGroup className="mr-3">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Home Phone</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="homephone"                     
                                            value={this.state.homephone}
                                            onChange={ this.handleInputChange }   
                                            ref ="homephone"  />
                                            {this.state.homephone_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["homephone"]}</span> :""}
                                            </InputGroup>

                                            <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Mobile Phone</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="mobilephone"                     
                                            value={this.state.mobilephone}
                                            onChange={ this.handleInputChange }   
                                            ref ="mobilephone"  />
                                            {this.state.mobilephone_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["mobilephone"]}</span>:""}
                                            </InputGroup>
                                            

                                            </div>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                        Name/address of employer <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                        <div className="">
                                            <Input type="textarea"  placeholder="Name/address of employer " name="nameaddressofemployer"                     
                                            value={this.state.nameaddressofemployer}
                                            onChange={ this.handleInputChange }   
                                            ref ="nameaddressofemployer" />
                                            {this.state.nameaddressofemployer_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["nameaddressofemployer"]}</span>:""}
                                            </div>
                                            
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                       &nbsp;
                                        </Label>
                                        <Col lg={10} >
                                        <div className="d-flex justify-content-left">

                                            <InputGroup className="mr-3">
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Work Phone</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="workphone"                     
                                            value={this.state.workphone}
                                            onChange={ this.handleInputChange }   
                                            ref ="workphone"  />
                                            {this.state.workphone_error == true ?<span className="error" style={{color: 'red'}}>{this.state.errors["workphone"]}</span>:""}
                                            </InputGroup>
                                            

                                            <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Occupation</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="occupation"                     
                                            value={this.state.occupation}
                                            onChange={ this.handleInputChange }   
                                            ref ="occupation"  />
                                            {this.state.occupation_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["occupation"]}</span> : ""}
                                            </InputGroup>
                                            

                                            </div>
                                        </Col>
                                    </FormGroup>

                                  <FormGroup row>
                                        <Label for="name" sm={2}>
                                        &nbsp;
                                        </Label>
                                        <Col lg={10} >
                                        <div className="d-flex justify-content-left">

                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                            <InputGroupText>E-mail address</InputGroupText>
                                            </InputGroupAddon>
                                            <Input name="emailaddress"                     
                                            value={this.state.emailaddress}
                                            onChange={ this.handleInputChange }   
                                            ref ="emailaddress"  />
                                            { this.state.emailaddress_error == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["emailaddress"]}</span>:""}
                                            </InputGroup>
                                            

                                            </div>
                                        </Col>
                                    </FormGroup>
                                    
                                    <FormGroup row>
                                        <Label for="status" sm={2}>
                                            Status<span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <Switch onChange={this.handleChange} checked={this.state.status}
                                            onColor = "#45b649"
                                            offColor = "#ffd700"
                                            width	= {120}
                                            ref ="status" 
                                        />
                                        {this.state.status_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["status"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup check row>
                                        <Col sm={{ size: 10, offset: 2 }}>
                                            <Button className="btn btn-primary" onClick={ this.handleSubmit }>Update Participant</Button>&nbsp;
                                            <Link to={"/allmentors"} className="btn btn-danger" title="Cancel">&nbsp;Cancel</Link>
                                        </Col>
                                    </FormGroup>
                                    {this.state.errMsg}
                                </Form>
                            </CardBody>
                        </Card>

                        
                    </Col>
                </Row>
            </Page>
        )
    }
}
export default AddMentor;